var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Card, CardMedia, Stack, Typography } from '@mui/material';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var SavedDesignCard = function (_a) {
    var onClick = _a.onClick, title = _a.title, caption = _a.caption, imgSrc = _a.imgSrc, actionableText = _a.actionableText, imgSrcSet = _a.imgSrcSet, imgAlt = _a.imgAlt, imgLoading = _a.imgLoading, rest = __rest(_a, ["onClick", "title", "caption", "imgSrc", "actionableText", "imgSrcSet", "imgAlt", "imgLoading"]);
    return (React.createElement(Card, __assign({ onClick: onClick, sx: __assign({ width: '100%' }, (onClick
            ? {
                cursor: 'pointer',
                '&:hover': {
                    borderColor: designTokens.color.gray.accent.value,
                    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
                },
                '&:active': {
                    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.15)',
                },
            }
            : {
                '&:hover': {
                    borderColor: designTokens.color.gray.accent.value,
                    boxShadow: 'none',
                },
            })) }, rest),
        React.createElement(CardMedia, { sx: { aspectRatio: '1/1' }, component: "img", image: imgSrc, srcSet: imgSrcSet, alt: imgAlt || title, loading: imgLoading, draggable: false }),
        React.createElement(Stack, { sx: { p: '8px', pt: '4px', gap: '2px' } },
            React.createElement(Typography, { variant: "heading5", color: designTokens.color.gray.obsidian.value, noWrap: true }, title),
            React.createElement(Typography, { variant: "uiTextTiny", color: designTokens.color.gray.slateDefault.value, noWrap: true }, caption),
            React.createElement(Typography, { variant: "uiTextSmall", color: designTokens.color.blue.default.value, noWrap: true }, actionableText))));
};
export default SavedDesignCard;
//# sourceMappingURL=SavedDesignCard.js.map